module.exports = __webpack_public_path__ + "static/img/biyao.4044f6e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/biyao.jpg
// module id = fONP
// module chunks = 1